import { render, staticRenderFns } from "./FindingTypesView.vue?vue&type=template&id=edef8d6a&"
import script from "./FindingTypesView.vue?vue&type=script&lang=ts&"
export * from "./FindingTypesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports